const AppConstants = {
    // api: 'http://localhost:5001',
    api: 'https://jaguar-traceabilty-jpmo2.ondigitalocean.app/',
    mqtt: {
        url: "wss://broker.digimach.io:61619",
        protocol: "wss",
        // port: 6969,
        // host: 'broker.qa.api.digimach.io',
        username: 'ubuntu',
        password: 'password@123'
    },
}
export default AppConstants
